<template>
  <div class="dialog">
    <myMask v-if="COUPONDIALOGDATA"></myMask>
    <div class="firework-grp" v-if="COUPONDIALOGDATA">
      <div class="firework pos1">
        <div class="drops-grp">
          <span class="drop drop-1"></span>
          <span class="drop drop-2"></span>
          <span class="drop drop-3"></span>
          <span class="drop drop-4"></span>
        </div>
        <div class="drops-grp drops-grp2">
          <span class="drop drop-1"></span>
          <span class="drop drop-2"></span>
          <span class="drop drop-3"></span>
          <span class="drop drop-4"></span>
        </div>
      </div>
      <div class="firework pos2 delay1">
        <div class="drops-grp">
          <span class="drop drop-1"></span>
          <span class="drop drop-2"></span>
          <span class="drop drop-3"></span>
          <span class="drop drop-4"></span>
        </div>
        <div class="drops-grp drops-grp2">
          <span class="drop drop-1"></span>
          <span class="drop drop-2"></span>
          <span class="drop drop-3"></span>
          <span class="drop drop-4"></span>
        </div>
      </div>
      <div class="firework pos4 delay2">
        <div class="drops-grp">
          <span class="drop drop-1"></span>
          <span class="drop drop-2"></span>
          <span class="drop drop-3"></span>
          <span class="drop drop-4"></span>
        </div>
        <div class="drops-grp drops-grp2">
          <span class="drop drop-1"></span>
          <span class="drop drop-2"></span>
          <span class="drop drop-3"></span>
          <span class="drop drop-4"></span>
        </div>
      </div>
    </div>
    <div class="timeg-dialogWin" v-show="COUPONDIALOGDATA" :class="{'is-comb': COUPONDIALOGDATA.isCombination}">
      <div class="title fs-18"></div>
      <slot name="top"></slot>
      <div class="fs-16 content">
        <div class="subtitle" v-html="COUPONDIALOGDATA.subtitle || '你被优惠券砸中啦'"></div>

        <div v-if="COUPONDIALOGDATA.isCombination" class="comb-content">
          <div
            class="comb-content-item" 
            v-for="(item, index) in COUPONDIALOGDATA.combination" 
            :key="index"
            @click="hanldeUse(item)"
          >
            <i :class="`is-${item.type}`"></i>
            <span class="comb-title">{{ item.title }}</span>
            <span class="comb-button">{{ item.button || '立即使用' }}</span>
          </div>
        </div>
        <template v-else>
          <div class="coupon">
            <div class="coupon-title">
              <div class="intitle">{{COUPONDIALOGDATA.popTitle}}</div>
              <div
                class="intis"
                v-if="COUPONDIALOGDATA.popDescription"
              >{{COUPONDIALOGDATA.popDescription}}</div>
            </div>
            <div
              :class="[COUPONDIALOGDATA.popCouponTypeDes.length > 4?'coupon-price-min':'coupon-price']"
            >{{COUPONDIALOGDATA.popCouponTypeDes}}</div>
          </div>
          <div class="dialog-timer">
            <div class="timer-title">{{ COUPONDIALOGDATA.expireTimeTitle || '优惠券有效时间' }}</div>
            <div v-if="COUPONDIALOGDATA.expireTime" class="timer-tis">
              <span v-if="endTime.day">{{endTime.day}}天</span>
              <span>{{endTime.hr}}</span>:
              <span>{{endTime.min}}</span>:
              <span>{{endTime.sec}}</span>
            </div>
          </div>
        </template>
      </div>
      <div v-if="!COUPONDIALOGDATA.isCombination" class="action">
        <div class="btnCont">
          <v-touch v-on:tap="callBack()" class="inbtn fs-16">立即使用</v-touch>
        </div>
      </div>
      <span class="coupondialog-close" @click.stop="close('isDialogClose')">
        <img src="../../assets/details/btn_close.png" />
      </span>
    </div>
  </div>
</template>

<script>
import myMask from "../common/mask";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
export default {
  components: {
    myMask
  },
  data() {
    return {
      mask: true,
      title: "",
      content: "",
      actions: [],
      show: false,
      endTime: {
        day: 0,
        hr: 0,
        min: 0,
        sec: 0
      },
      initPropTime: ""
    };
  },
  mounted() {
    this.initPropTime = this.COUPONDIALOGDATA.expireTime;
    this.inEndTime();
  },
  computed: {
    ...mapGetters(["COUPONDIALOGDATA"])
  },
  methods: {
    ...mapMutations(["setCouponDialogData"]),
    inEndTime() {
      //倒计时结束
      const that = this;
      if (this.initPropTime < 2) {
        return;
      }
      this.initPropTime = this.initPropTime - 1000;
      let day = parseInt(this.initPropTime / 1000 / 60 / 60 / 24);
      let hr = parseInt((this.initPropTime / 1000 / 60 / 60) % 24);
      let min = parseInt((this.initPropTime / 1000 / 60) % 60);
      let sec = parseInt((this.initPropTime / 1000) % 60);
      this.endTime.day = day;
      this.endTime.hr = hr > 9 ? hr : "0" + hr;
      this.endTime.min = min > 9 ? min : "0" + min;
      this.endTime.sec = sec > 9 ? sec : "0" + sec;
      let timer = setTimeout(function() {
        that.inEndTime();
        clearTimeout(timer);
      }, 1000);
    },
    callBack() {
      console.log("关闭优惠券")
      const scope = this.COUPONDIALOGDATA.scope
      if (!scope) {
        this.$emit('use')
      }
      if (!scope || (scope === 1 && this.$route.name === 'testDetail')) {
        this.close();
        return;
      }
      if (scope == 3) {
        this.$router.push({
          name: "testDetail",
          path: "/detail",
          params: {
            testId: this.COUPONDIALOGDATA.scalePoolIds[0]
          },
          query: {
            channelId: this.channelId
          }
        });
      } else {
        this.$router.push({
          name: "sorts",
          path: "/sorts",
          query: {
            channelId: this.channelId,
            sort: "全部"
          }
        });
      }
      this.close();
    },
    close() {
      this.$emit('close')
      this.setCouponDialogData("");
    },

    hanldeUse(item) {
      this.$emit('use', item)
      this.close()
    }
  }
};
</script>

<style lang="scss" scoped>
$font-size-base: 75; // Base on 750px;
@function topx($rem) {
  @return $rem/$font-size-base;
}

.dialog {
  .timeg-dialogWin {
    position: fixed;
    top: 0;
    left: 50%;
    width: topx(450rem);
    height: topx(826rem);
    transform: translate3d(-50%, 0, 0);
    z-index: 12;
    border-radius: 6px;
    animation: intoDialog 1s ease-out;
    background: url("../../assets/details/img-coupon-bg.png") center
      no-repeat;
    background-size: 100% 100%;

    &.is-comb {
      background: url("../../assets/details/img-bg-comb.png") center
      no-repeat;
      background-size: 100% 100%;
    }

    @keyframes intoDialog {
      0% {
        transform: translate3d(-50%, -100%, 0);
      }
      70% {
        transform: translate3d(-50%, 0, 0);
      }
      85% {
        transform: translate3d(-50%, -5%, 0);
      }
      100% {
        transform: translate3d(-50%, 0, 0);
      }
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
      font-style: normal;
      width: topx(44rem);
      height: auto;
      line-height: 1.22;
      text-align: center;
    }
    .title {
      height: auto;
      line-height: 1.67;
      text-align: center;
      padding: topx(15rem) 0;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.empty {
        height: topx(18rem);
        padding: 0;
      }
    }
    .content {
      line-height: 1.78;
      min-height: topx(114rem);
      color: #666;
      overflow: hidden;
      position: relative;
      margin-top: topx(350rem);

      .subtitle {
        margin-bottom: topx(20rem);
        font-size: topx(32rem);
        line-height: topx(38rem);
        text-align: center;
        color: #FFF9D8;
      }

      img {
        width: 100%;
        height: auto;
      }
      .coupon {
        height: topx(135rem);
        overflow: hidden;
        margin: 0 topx(25rem);
        padding-top: topx(10rem);
        display: flex;
        background: url(~@/assets/details/img-coupon-price.png) no-repeat;
        background-size: cover;

        .coupon-title {
          width: topx(280rem);
          height: topx(125rem);
          flex: 1 1 auto;
          display: flex;
          justify-content: center;
          flex-direction: column;
          .intitle {
            text-align: left;
            font-size: topx(28rem);
            color: #5d1800;
            line-height: topx(28rem);
            margin-left: topx(25rem);
          }
          .intis {
            text-align: left;
            margin-top: topx(10rem);
            font-size: topx(22rem);
            color: #8a5d4d;
            line-height: topx(22rem);
            margin-left: topx(20rem);
          }
        }
        .coupon-price {
          height: topx(120rem);
          font-size: topx(38rem);
          color: #ff3d3d;
          text-align: center;
          line-height: topx(38rem);
          width: topx(110rem);
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          span {
            font-size: topx(50rem);
          }
        }
        .coupon-price-min {
          height: topx(120rem);
          font-size: topx(28rem);
          color: #ff3d3d;
          text-align: center;
          line-height: topx(38rem);
          width: topx(110rem);
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
        }
      }
      .dialog-timer {
        font-size: topx(24rem);
        color: #fff9d8;
        text-align: center;
        line-height: topx(24rem);
        text-align: center;
        margin-top: topx(15rem);
        min-height: topx(90rem);
        // overflow: hidden;
        .dialog-timer_tis {
          font-size: topx(28rem);
          color: #fff9d8;
          text-align: center;
          line-height: topx(28rem);
          margin-top: topx(10rem);
        }
        .timer-title {
          font-size: topx(32rem);
          color: #fff9d8;
          text-align: center;
          line-height: topx(32rem);
        }
        .timer-tis {
          margin-top: topx(15rem);
        }
        span {
          // width: topx(34rem);
          height: topx(40rem);
          line-height: topx(40rem);
          text-align: center;
          background: #d0021b;
          border-radius: topx(5rem);
          font-size: topx(22rem);
          color: #fff;
          letter-spacing: 0;
          line-height: topx(40rem);
          padding: 0 topx(5rem);
          margin-left: topx(5rem);
          margin-right: topx(5rem);
          display: inline-block;
          letter-spacing: 0;
        }
      }
    }
    .action {
      position: absolute;
      width: 100%;
      bottom: topx(50rem);
      display: flex;
      .btnCont {
        flex: 1 1 0;
        text-align: center;
      }
      .inbtn {
        display: block;
        width: 100%;
        height: topx(64rem);
        text-align: center;
        font-weight: 600;
        color: #FF5116;
        font-size: topx(28rem);
        letter-spacing: topx(3rem);
      }
    }
    .coupondialog-close {
      position: absolute;
      bottom: topx(-90rem);
      left: 50%;
      margin-left: topx(-25rem);
      width: topx(50rem);
      height: topx(50rem);
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .firework-grp {
    display: block;
    width: 100%;
    height: topx(1334rem);
    position: fixed;
    color: #fff9d8;
    top: 0;
    left: 0;
    z-index: 10;
    /* POSITION
              ------------------------------------*/
    .pos1 {
      left: topx(190rem);
      top: topx(120rem);
      transform: scale(0.4);
    }
    .pos2 {
      left: topx(350rem);
      top: topx(45rem);
      transform: scale(0.7);
    }
    .pos3 {
      left: topx(120rem);
      top: topx(165rem);
      transform: scale(0.2);
    }
    .pos4 {
      left: topx(450rem);
      top: topx(160rem);
      transform: scale(0.6);
    }
  }

  .firework-grp2 {
    transform: rotate(180deg);
    color: #2c1c44;
    z-index: 6;
  }
  .firework-grp3 {
    transform: rotate(-75deg);
    color: #e339bd;
    z-index: 7;
  }
  .firework {
    font-size: 10px;
    display: block;
    width: topx(200rem);
    height: topx(200rem);
    position: absolute;
  }

  /* FIREWORK
        ------------------------------------*/
  .drops-grp {
    display: block;
    width: topx(200rem);
    height: topx(200rem);
    position: absolute;
  }
  .drops-grp2 {
    display: block;
    width: topx(200rem);
    height: topx(200rem);
    position: absolute;
    transform: rotate(45deg);
  }
  .drop {
    display: block;
    width: topx(20rem);
    height: topx(40rem);
    overflow: hidden;
    position: absolute;
    opacity: 0;
  }
  .drop:before {
    content: "";
    display: block;
    width: topx(20rem);
    height: topx(20rem);
    background: currentColor;
    border-radius: 50%;
  }
  .drop:after {
    content: "";
    display: block;
    position: relative;
    width: 0;
    height: 0;
    border-top: topx(28rem) solid currentColor;
    border-left: topx(10rem) solid transparent;
    border-right: topx(10rem) solid transparent;
    top: topx(-6rem);
  }
  .drop-1 {
    left: topx(95rem);
    top: 0;
    animation: drop1anim 1s ease-in-out infinite;
  }
  .drop-2 {
    top: topx(80rem);
    right: 0;
    animation: drop2anim 1s ease-in-out infinite;
  }
  .drop-3 {
    left: topx(95rem);
    bottom: 0;
    animation: drop3anim 1s ease-in-out infinite;
  }
  .drop-4 {
    top: topx(80rem);
    left: 0;
    animation: drop4anim 1s ease-in-out infinite;
  }
  .firework-2 .drop-1 {
    animation-delay: 0.5s;
  }
  .firework-2 .drop-2 {
    animation-delay: 0.5s;
  }
  .firework-2 .drop-3 {
    animation-delay: 0.5s;
  }
  .firework-2 .drop-4 {
    animation-delay: 0.5s;
  }

  /* FIREWORK DELAY
        ------------------------------------*/
  .delay1 .drop-1 {
    animation-delay: 0.5s;
  }
  .delay1 .drop-2 {
    animation-delay: 0.5s;
  }
  .delay1 .drop-3 {
    animation-delay: 0.5s;
  }
  .delay1 .drop-4 {
    animation-delay: 0.5s;
  }

  .delay2 .drop-1 {
    animation-delay: 1s;
  }
  .delay2 .drop-2 {
    animation-delay: 1s;
  }
  .delay2 .drop-3 {
    animation-delay: 1s;
  }
  .delay2 .drop-4 {
    animation-delay: 1s;
  }

  /* keyframes
        ------------------------------------*/
  @keyframes drop1anim {
    0% {
      top: 3.25em;
      opacity: 0;
      transform: scale(0.3);
    }
    25% {
      opacity: 0;
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      top: -0.75em;
      opacity: 0;
      transform: scale(0.3);
    }
  }
  @keyframes drop2anim {
    0% {
      right: 3.75em;
      opacity: 0;
      transform: scale(0.3) rotate(90deg);
    }
    25% {
      opacity: 0;
    }
    50% {
      opacity: 1;
      transform: scale(1) rotate(90deg);
    }
    100% {
      right: -0.25em;
      opacity: 0;
      transform: scale(0.3) rotate(90deg);
    }
  }
  @keyframes drop3anim {
    0% {
      bottom: 3.25em;
      opacity: 0;
      transform: scale(0.3) rotate(180deg);
    }
    25% {
      opacity: 0;
    }
    50% {
      opacity: 1;
      transform: scale(1) rotate(180deg);
    }
    100% {
      bottom: -0.75em;
      opacity: 0;
      transform: scale(0.3) rotate(180deg);
    }
  }
  @keyframes drop4anim {
    0% {
      left: 3.75em;
      opacity: 0;
      transform: scale(0.3) rotate(-90deg);
    }
    25% {
      opacity: 0;
    }
    50% {
      opacity: 1;
      transform: scale(1) rotate(-90deg);
    }
    100% {
      left: -0.25em;
      opacity: 0;
      transform: scale(0.3) rotate(-90deg);
    }
  }
}

.comb-content {
  margin-left: topx(23rem);

  .comb-content-item {
    display: flex;
    align-items: center;
    width: topx(404rem);
    height: topx(119rem);
    padding: 0 topx(26rem) topx(10rem) topx(27rem);
    margin-bottom: topx(-20rem);
    background: url(~@/assets/details/img-tf-coupon-bg.png) no-repeat;
    background-size: contain;
    color: #5D1800;
    font-size: topx(26rem);
    box-sizing: border-box;

    i {
      flex-shrink: 0;
      margin-right: topx(12rem);
      width: topx(40rem);
      height: topx(40rem);
      background: url(~@/assets/details/icon-tf-coupon.png) no-repeat;
      background-size: contain;

      &.is-vip {
        background: url(~@/assets/details/icon-tf-vip.png) no-repeat;
        background-size: contain;
      }

      &.is-connect {
        background: url(~@/assets/details/icon-tf-connect.png) no-repeat;
        background-size: contain;
      }

      &.is-coupon {
        background: url(~@/assets/details/icon-tf-coupon.png) no-repeat;
        background-size: contain;
      }
    }

    .comb-title {
      flex: 1;
      line-height: topx(24rem);
    }

    .comb-button {
      flex-shrink: 0;
      width: topx(124rem);
      height: topx(44rem);
      background: linear-gradient(180deg, #FFE4A9 0%, #FFEABE 47%, #FFCA59 100%);
      box-shadow: 0 topx(10rem) topx(8rem) topx(-9rem) rgba(127,0,0,0.5000);
      border-radius: topx(23rem);
      text-align: center;
      line-height: topx(44rem);
      color: #FF5116;
      font-size: topx(20rem);
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/show/globalLimitTimeg.vue